import { useAppDispatch } from "../../store/hooks";
import { resetModals } from "../../store/slices/modalsSlice";
import { Button } from "../ui/button";
import ModalWrapper from "./ModalWrapper";

const GeneralMessageModal = ({
  msg,
  btnMsg,
  closeOnClick = true,
}: {
  msg: string;
  btnMsg: string;
  closeOnClick?: boolean;
}) => {
  const dispatch = useAppDispatch();
  return (
    <ModalWrapper closeOnClick={closeOnClick}>
      <div
        className="text-center bg-white rounded-xl px-5 py-6 space-y-6"
        style={{ minWidth: "25%" }}
      >
        <p className="text-2xl">{msg}</p>
        <Button
          className="text-white rounded-lg bg-primary"
          onClick={() => {
            dispatch(resetModals());
          }}
        >
          {btnMsg}
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default GeneralMessageModal;
